import PropTypes from 'prop-types'
import { isNil } from 'ramda'

class BaseCost {
  constructor(init) {
    // console.log('> BaseCost constructor -', init)
    if (isNil(init)) return undefined
    this._total = init.total
    this._copay = init.copay
    this._deductible = init.deductible
    this._care_estimate = init.care_estimate
    this._insurance_copay = init.insurance_copay
    this._insurance_pays = init.insurance_pays
    this._user_pays = init.user_pays
  }

  static shape = {
    total: PropTypes.number,
    copay: PropTypes.number,
    deductible: PropTypes.number,
    care_estimate: PropTypes.string,
    insurance_copay: PropTypes.number,
    insurance_pays: PropTypes.number,
    user_pays: PropTypes.number
  }

  get total() {
    return this._total || 0
  }

  get copay() {
    return this._copay || 0
  }

  get deductible() {
    return this._deductible || 0
  }

  get care_estimate() {
    return this._care_estimate || ''
  }

  get insurance_copay() {
    return this._insurance_copay || 0
  }

  get insurance_pays() {
    return this._insurance_pays || 0
  }

  get user_pays() {
    return this._user_pays || 0
  }

  // Calculable
  get convertToEstimate() {
    return {
      cost: this.total,
      cost_copay: this.copay,
      cost_coinsurance: this.insurance_copay,
      cost_deductible: this.deductible,
      cost_not_covered: this.user_pays
    }
  }
}

export default BaseCost
